<template>
  <div class="flex size-full bg-surface-tertiary">
    <div
      id="sidebar"
      class="flex min-w-2 overflow-hidden"
      data-test="sidebar"
    >
      <div class="flex size-full flex-col">
        <slot name="sidebar" />
      </div>
    </div>
    <div
      id="page-container"
      class="flex grow flex-col [contain:strict]"
    >
      <slot name="page-header" />
      <div
        class="min-h-0 grow overflow-y-auto rounded-tl-lg bg-surface-primary scrollbar-thin scrollbar-track-background-transparent scrollbar-thumb-background-gray-subtle scrollbar-track-rounded-md"
      >
        <slot name="page" />
      </div>
    </div>
  </div>
</template>
